<div class="d-flex align-items-center">
    <div class="status-round-icon bg-{{PR_ASSIGN_COLOUR_DICT[assignStatus]}} me-1"
        [ngClass]="{'status-grey-border': assignStatus === 'Skipped'}"
    ></div>
    <p class="f-small">{{assignStatus}}</p>
</div>